var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniOrdersTimes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "15px",
    viewBox: "0 0 26 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fillOpacity: 0.6,
    fill: "#121212",
    fillRule: "nonzero",
    transform: "translate(23.228823, 7.861177) rotate(-315.000000) translate(-23.228823, -7.861177) ",
    points: "23.9279751 12.3611775 23.9279751 8.49677071 27.7415344 8.49677071 27.7415344 7.22558427 23.9279751 7.22558427 23.9279751 3.36117749 22.52967 3.36117749 22.52967 7.22558427 18.7161106 7.22558427 18.7161106 8.49677071 22.52967 8.49677071 22.52967 12.3611775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0.288675135 L13.4951905,3.46132487 C13.8045916,3.63995766 13.9951905,3.97008468 13.9951905,4.32735027 L13.9951905,10.6726497 C13.9951905,11.0299153 13.8045916,11.3600423 13.4951905,11.5386751 L8,14.7113249 C7.69059892,14.8899577 7.30940108,14.8899577 7,14.7113249 L1.50480947,11.5386751 C1.19540839,11.3600423 1.00480947,11.0299153 1.00480947,10.6726497 L1.00480947,4.32735027 C1.00480947,3.97008468 1.19540839,3.63995766 1.50480947,3.46132487 L7,0.288675135 C7.30940108,0.11004234 7.69059892,0.11004234 8,0.288675135 Z",
    id: "Polygon-Copy-25",
    fill: "#4157A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniOrdersTimes);
export default __webpack_public_path__ + "static/media/mini-orders-times.4ee521686d17ba3a2c641a8d18c701c0.svg";
export { ForwardRef as ReactComponent };